import styled from 'styled-components';

export const Spacer = styled(({ top = 0, bottom = 0, left = 0, right = 0, ...rest }) => (
  <div {...rest} />
))((p) => ({
  marginTop: p.theme.spacing[`m${p.top}`],
  marginBottom: p.theme.spacing[`m${p.bottom}`],
  marginLeft: p.theme.spacing[`m${p.left}`],
  marginRight: p.theme.spacing[`m${p.right}`],
}));
